"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLNetworkDestination = void 0;
exports.SLNetworkDestination = {
    D2C_NETWORK: "D2C_NETWORK",
    STORAGE: "STORAGE",
};
//# sourceMappingURL=slnetwork-destination.js.map